// Import preact/debug somewhere to initialize the connection to the extension.
// Make sure that this import is the first import in your whole app.
if (import.meta.env.DEV) import('preact/debug');

import { render } from 'preact';

import { AppWrapper } from './app/ui/AppWrapper';
import { applyInitialStyles } from './shared/helpers/telegram/apply-initial-styles';
import { initApplication } from './shared/scripts/init-application';
import { ErrorLogger } from './shared/service/logger/ErrorLogger';
import { ErrorPage } from './widget/error-page/ui';

import '@/app/styles/core.scss';

// Применяем стили синхронно, до рендера React компонентов
applyInitialStyles();

window.addEventListener('error', (event) => {
  ErrorLogger.error(event.error, 'root event handler');
});

const renderApp = () => {
  const rootElement = document.getElementById('root');

  if (!rootElement) return;

  initApplication()
    .then(() => {
      render(<AppWrapper />, rootElement);
    })
    .catch((error: Error) => {
      render(<ErrorPage message={error.message} />, rootElement);
    });
};

renderApp();
